import { initLiffAndSetSessionSubscription } from "./liff.js"

document.addEventListener("turbo:load", function() {
  initLiffAndSetSessionSubscription("profile-lakhana")
})

